import { z } from 'zod';
import { TRUE_FALSE } from './helpers/enums.ts';

export const tunDisabledSchema = z.enum([...TRUE_FALSE, '']);
export const tunDisabledRequiredSchema = tunDisabledSchema.refine((val) => val !== '', {
  message: 'Choose whether the nebula interface should be disabled',
});
